<template>
  <section class="app-main">
    <transition name="fade" mode="out-in"  >
      <keep-alive v-if="$route.meta.keepAlive">
        <router-view></router-view>
      </keep-alive>
      <router-view v-else></router-view>
    </transition>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    isKeepAlive(){
      console.log(this.keepAlives.includes(this.$route.fullPath))
      return this.keepAlives.includes(this.$route.fullPath)
    }
    // key() {
    //   return this.$route.name !== undefined ? this.$route.name + +new Date() : this.$route + +new Date()
    // }
  },
  data(){
    return {
      keepAlives: ['/oms/order','/oms/orderDetail']
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/layout/components/AppMain.vue